import React from "react";
import { Input, InputProps } from "@chakra-ui/react";
import { PropsWithChildren } from "react";

const ThemedInputComponent = React.forwardRef<
  HTMLInputElement,
  PropsWithChildren<InputProps>
>(({ children, ...rest }, ref) => {
  return (
    <Input
      ref={ref}
      rounded="none"
      variant="outline"
      size="lg"
      borderColor="gray.400"
      {...rest}
    />
  );
});

ThemedInputComponent.displayName = "ThemedInput";

export const ThemedInput = ThemedInputComponent;
